<div class="col-md-6 offset-md-3 mt-5">

  <div class="ng-container registration-logo">
    <img src="assets/billdeo_logo.png">
  </div>
  <div class="card">
    <h4 class="card-header">Billdeo - Registration</h4>
    <div class="card-body">
      <form [formGroup]="registrationForm"  (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label class="sr-only" for="firstname">First Name</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
            </div>
            <input type="text" formControlName="firstname" class="form-control py-0" name="firstname" id="firstname" [pattern]="namePattern" placeholder="First name" [ngClass]="{ 'is-invalid': submitted && f.firstname.errors, 'is-valid': f.firstname.valid && f.firstname.touched }" >
            @if (f.firstname && f.firstname.errors) {
              <div class="invalid-feedback">
                @if (f.firstname.errors.required) {
                  <div>First name must be entered e.g John</div>
                }
              </div>
            }
            @if (f.firstname && f.firstname.errors?.pattern ) {
              <div class="invalid-feedback">
                First name must be entered in the format e.g John
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="sr-only" for="lastname">Last Name</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
            </div>
            <input type="text" formControlName="lastname" class="form-control py-0" name="lastname" id="lastname" [pattern]="namePattern" placeholder="Last name" [ngClass]="{ 'is-invalid': submitted && f.lastname.errors, 'is-valid': f.lastname.valid && f.lastname.touched }" >
            @if (f.lastname && f.lastname.errors) {
              <div class="invalid-feedback">
                @if (f.lastname.errors.required) {
                  <div>Last name be entered e.g Brown</div>
                }
              </div>
            }
            @if (f.lastname && f.lastname.errors?.pattern ) {
              <div class="invalid-feedback">
                Last name must be entered in the format e.g Brown
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="sr-only" for="username">Username</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faUser"></fa-icon></div>
            </div>
            <input type="text" formControlName="username" class="form-control py-0" name="username" id="username" [pattern]="namePattern" placeholder="Username" [ngClass]="{ 'is-invalid': submitted && f.username.errors, 'is-valid': f.username.valid && f.username.touched }" >
            @if (f.username && f.username.errors) {
              <div class="invalid-feedback">
                @if (f.username.errors.required) {
                  <div>Username must be entered, no spaces</div>
                }
              </div>
            }
            @if (f.username && f.username.errors?.pattern ) {
              <div class="invalid-feedback">
                Username must be entered, no spaces
              </div>
            }
          </div>
        </div>

        <div class="form-group">

          <label class="sr-only" for="phone">Phone</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faPhoneAlt"></fa-icon></div>
            </div>
            <input type="text" formControlName="phone" class="form-control py-0" id="inlineFormInputGroup" placeholder="Phone" pattern="^\d{10}$" [ngClass]="{ 'is-invalid': submitted && f.phone.errors, 'is-valid': f.phone.valid && f.phone.touched }">
            @if (submitted && f.phone.errors) {
              <div class="invalid-feedback">
                @if (f.phone.errors.required) {
                  <div>Phone number is required</div>
                }
              </div>
            }
            @if (f.phone && f.phone.errors?.pattern) {
              <div class="invalid-feedback">
                10 digit Phone number, without space or dash
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="sr-only" for="email">Email</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faEnvelope"></fa-icon></div>
            </div>
            <input type="email" formControlName="email" class="form-control py-0" name="email" id="email"  placeholder="Email" [pattern]="emailPattern"  [ngClass]="{ 'is-invalid': submitted && f.email.errors, 'is-valid': f.email.valid && f.email.touched }" >
            @if (submitted && f.email.errors) {
              <div class="invalid-feedback">
                @if (f.email.errors.required) {
                  <div>Email is required</div>
                }
              </div>
            }
            @if (f.email && f.email.errors?.pattern) {
              <div class="invalid-feedback">
                Email address is not valid
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="sr-only" for="password">Password</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
            </div>
            <input type="password" formControlName="password" class="form-control py-0" (change)="onPasswordChange()" name="password" id="password"  placeholder="Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.password.errors, 'is-valid': f.password.valid && f.password.touched }" >
            @if (submitted && f.password.errors) {
              <div class="invalid-feedback">
                @if (f.password.errors.required) {
                  <div>Password is required</div>
                }
              </div>
            }
            @if (f.password && f.password.errors?.pattern) {
              <div class="invalid-feedback">
                Password has to be 5 or more characters.
              </div>
            }
          </div>
        </div>

        <div class="form-group">
          <label class="sr-only" for="confirmPassword">Password</label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><fa-icon [icon]="faKey"></fa-icon></div>
            </div>
            <input type="password" formControlName="confirmPassword" class="form-control py-0" (change)="onPasswordChange()" name="confirmPassword" id="confirmPassword"  placeholder="Confirm Password" [pattern]="passwordPattern"  [ngClass]="{ 'is-invalid': submitted && f.confirmPassword.errors, 'is-valid': f.confirmPassword.valid && f.confirmPassword.touched }" >
            @if (submitted && f.confirmPassword.errors) {
              <div class="invalid-feedback">
                @if (f.confirmPassword.errors.required) {
                  <div>Please confirm password</div>
                }
              </div>
            }
            @if (f.confirmPassword && f.confirmPassword.errors?.pattern) {
              <div class="invalid-feedback">
                Confirm Password has to be 5 or more characters. Less than 30 characters.
              </div>
            }
            @if (f.password && f.confirmPassword && f.confirmPassword.hasError('mismatch')) {
              <div class="invalid-feedback">
                Passwords do not match
              </div>
            }
          </div>
        </div>

        @if (error) {
          <div class="alert alert-danger my-2 mt-3">{{error}}</div>
        }

        <button [disabled]="loading" class="btn btn-success float-right">
          @if (loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          Register <fa-icon class="l-icon" [icon]="faPaperPlane"></fa-icon>
        </button>


      </form>
    </div>

  </div>
</div>
